// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"d4f20a04","100":"a406d4ce","444":"91e1e01a","704":"cf0deeb4","884":"dce12d8c"}[chunkId] + ".chunk.css";
};